// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-white: #fff;
  --primary-black: #000;
  --primary-grey: #73739a;
  --primary-grey2: #fffc;
  --primary-blue: #6d72f6;
  --primary-green: #08ce8a;
  --primary-black2: #1c1c57;
}

.long-container {
  font-family: Arial, sans-serif;
  margin: 20px;
  padding: 20px;
  /* background-color: #f9f9f9;
  border: 1px solid #ddd; */
  border-radius: 8px;
}

.long-container h1 {
  color: var(--primary-blue);
  font-size: 24px;
}

.long-container h2 {
  color: var(--primary-blue);
  font-size: 20px;
  margin-top: 20px;
}

.long-container hr {
  border: 0;
  height: 1px;
  background: #ddd;
  margin: 10px 0;
}

.long-container p {
  line-height: 2rem;
  color: var(--primary-grey);
  margin: 10px 0;
}

.long-container ul {
  margin: 10px 0;
  padding-left: 20px;
  color: #666;
}

.long-container ul li {
  margin: 5px 0;
}
.long-box-blur{
  background: url('https://fintect-qfoqi8eee-sk-ashadul-hossains-projects.vercel.app/static/media/Ellipse%209%20(3).5abd938acb2e90f40872.png');
  position: absolute;
  background-size: cover;
  width: 1200px;
  height: 1000px;
  z-index: -1;
  top: 0;
  right: 0;
  rotate: 180deg;
  }
.button-long-container {
  margin-top: 20px;
  display: flex;
  gap: 10px;
}

button {
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  color: white;
  font-weight: bold;
}

.whatsapp {
  background-color: #25D366;
}

.telegram {
  background-color: #0088cc;
}

.skype {
  background-color: #00aff0;
}

.long-long-container{
  display: flex;
  align-items: center;
  width: 100%;
  /* gap: 50px; */
}
.long-long-container ul li{
  line-height: 40px;
}
.long-box-img{
  display: flex;
  justify-content: center;
  width: 50%;
}


.long-container {
  font-family: Arial, sans-serif;
  margin: 20px;
  padding: 20px;
  background: #e2ecff8a;
  backdrop-filter: blur(10px);
  /* border: 1px solid #ddd; */
  /* border-radius: 8px; */
  position: relative;
  z-index: 1;
}

/* h1 {
  color: #333;
  font-size: 24px;
} */

hr {
  border: 0;
  height: 1px;
  background: #ddd;
  margin: 10px 0;
}
.long-sim-box{
  display: flex;
  gap: 20px;
}

.long-sim-img{
  flex: 1 1 30%;
}

.long-sim-img img{
  width: 100%;
  max-width: 550px;
}

.content-box{
  flex: 1 1 70%;
}

/* .content-box {
  margin-top: 20px;
  padding: 20px;
  /* background-color: #fff; */
  /* border: 1px solid #ccc; */
  /* border-radius: 8px; */
  /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */
/* }  */


@media (max-width: 1024px){
  .long-sim-box{
    flex-direction: column;
  }
  .long-sim-img img{
    max-width: 100%;
  }
}

@media (max-width: 768px){
  .long-long-container {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/VAS_Service/ExtraMiniCard/solutions.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb;2BACyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;AACA;EACE,4IAA4I;EAC5I,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,WAAW;EACX,MAAM;EACN,QAAQ;EACR,cAAc;EACd;AACF;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;AACZ;;;AAGA;EACE,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;;GAGG;;AAEH;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;;8BAG8B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,8CAA8C;AAChD,OAAO;;;AAGP;EACE;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[":root {\n  --primary-white: #fff;\n  --primary-black: #000;\n  --primary-grey: #73739a;\n  --primary-grey2: #fffc;\n  --primary-blue: #6d72f6;\n  --primary-green: #08ce8a;\n  --primary-black2: #1c1c57;\n}\n\n.long-container {\n  font-family: Arial, sans-serif;\n  margin: 20px;\n  padding: 20px;\n  /* background-color: #f9f9f9;\n  border: 1px solid #ddd; */\n  border-radius: 8px;\n}\n\n.long-container h1 {\n  color: var(--primary-blue);\n  font-size: 24px;\n}\n\n.long-container h2 {\n  color: var(--primary-blue);\n  font-size: 20px;\n  margin-top: 20px;\n}\n\n.long-container hr {\n  border: 0;\n  height: 1px;\n  background: #ddd;\n  margin: 10px 0;\n}\n\n.long-container p {\n  line-height: 2rem;\n  color: var(--primary-grey);\n  margin: 10px 0;\n}\n\n.long-container ul {\n  margin: 10px 0;\n  padding-left: 20px;\n  color: #666;\n}\n\n.long-container ul li {\n  margin: 5px 0;\n}\n.long-box-blur{\n  background: url('https://fintect-qfoqi8eee-sk-ashadul-hossains-projects.vercel.app/static/media/Ellipse%209%20(3).5abd938acb2e90f40872.png');\n  position: absolute;\n  background-size: cover;\n  width: 1200px;\n  height: 1000px;\n  z-index: -1;\n  top: 0;\n  right: 0;\n  rotate: 180deg;\n  }\n.button-long-container {\n  margin-top: 20px;\n  display: flex;\n  gap: 10px;\n}\n\nbutton {\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  color: white;\n  font-weight: bold;\n}\n\n.whatsapp {\n  background-color: #25D366;\n}\n\n.telegram {\n  background-color: #0088cc;\n}\n\n.skype {\n  background-color: #00aff0;\n}\n\n.long-long-container{\n  display: flex;\n  align-items: center;\n  width: 100%;\n  /* gap: 50px; */\n}\n.long-long-container ul li{\n  line-height: 40px;\n}\n.long-box-img{\n  display: flex;\n  justify-content: center;\n  width: 50%;\n}\n\n\n.long-container {\n  font-family: Arial, sans-serif;\n  margin: 20px;\n  padding: 20px;\n  background: #e2ecff8a;\n  backdrop-filter: blur(10px);\n  /* border: 1px solid #ddd; */\n  /* border-radius: 8px; */\n  position: relative;\n  z-index: 1;\n}\n\n/* h1 {\n  color: #333;\n  font-size: 24px;\n} */\n\nhr {\n  border: 0;\n  height: 1px;\n  background: #ddd;\n  margin: 10px 0;\n}\n.long-sim-box{\n  display: flex;\n  gap: 20px;\n}\n\n.long-sim-img{\n  flex: 1 1 30%;\n}\n\n.long-sim-img img{\n  width: 100%;\n  max-width: 550px;\n}\n\n.content-box{\n  flex: 1 1 70%;\n}\n\n/* .content-box {\n  margin-top: 20px;\n  padding: 20px;\n  /* background-color: #fff; */\n  /* border: 1px solid #ccc; */\n  /* border-radius: 8px; */\n  /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */\n/* }  */\n\n\n@media (max-width: 1024px){\n  .long-sim-box{\n    flex-direction: column;\n  }\n  .long-sim-img img{\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 768px){\n  .long-long-container {\n    flex-direction: column;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
